'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getIdleOnlineUserIds = exports.getIdleOnlineUsers = exports.getRemoteActiveCurrentlyViewedBoardIds = exports.getOnlineUsers = exports.getRemoteCurrentlyViewedBoardIds = exports.getTrackedUserIds = undefined;

var _reselect = require('reselect');

var _milanoteReselect = require('../milanoteReselect/milanoteReselect');

var _userUtil = require('../../user/userUtil');

var _immutableHelper = require('../../../common/utils/immutableHelper');

var _currentUserSelector = require('../../user/currentUserSelector');

var _userConstants = require('../../../common/users/userConstants');

// Selectors
// Lib
var getTrackedUserIds = exports.getTrackedUserIds = (0, _milanoteReselect.createShallowSelector)(function (state) {
    return state.get('users').keySeq().toArray();
}, function (trackedUserIds) {
    return trackedUserIds;
});

// Constants


// Util


var getCurrentlyViewedBoardIds = function getCurrentlyViewedBoardIds(users) {
    return users.reduce(function (boardIds, user) {
        var usersCurrentBoardId = user.get('currentBoardId');
        if (!!usersCurrentBoardId && boardIds.indexOf(usersCurrentBoardId) === -1) {
            boardIds.push(usersCurrentBoardId);
        }
        return boardIds;
    }, []);
};

var getRemoteCurrentlyViewedBoardIds = exports.getRemoteCurrentlyViewedBoardIds = (0, _milanoteReselect.createShallowSelector)(function (state) {
    return state.get('users');
}, getCurrentlyViewedBoardIds);

var getOnlineUsers = exports.getOnlineUsers = (0, _reselect.createSelector)(function (state) {
    return state.get('users').filter(_userUtil.isOnline);
}, function (users) {
    return users;
});

var getRemoteActiveCurrentlyViewedBoardIds = exports.getRemoteActiveCurrentlyViewedBoardIds = (0, _milanoteReselect.createShallowSelector)(getOnlineUsers, getCurrentlyViewedBoardIds);

var getIdleOnlineUsers = exports.getIdleOnlineUsers = (0, _reselect.createSelector)(getOnlineUsers, _currentUserSelector.getCurrentUserId, function (onlineUsers, currentUserId) {
    var currentTime = Date.now();
    // Find every user that might be stale because we haven't heard from them within the idle timeout
    var idleTimestamp = currentTime - _userConstants.USER_IDLE_TIMEOUT_MILLISECONDS;
    return onlineUsers.filter(function (user) {
        return user.get('timestamp') < idleTimestamp && currentUserId !== user.get('_id');
    });
});

var getIdleOnlineUserIds = exports.getIdleOnlineUserIds = (0, _milanoteReselect.createShallowSelector)(getIdleOnlineUsers, _immutableHelper.toIdArray);


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/collaboration/remoteUsersSelector.js
// module id = 237
// module chunks = 0